"use strict";
import moment from 'moment';
function momentTime(date) {
    return date ? moment(date).format('LT') : moment().format('LT')
};

export default momentTime;